import { routeGeometryKey } from "../../route-block/route-block.resolver.utils";
import { IMapLibreRouteResolverProps } from "./maplibre-route-resolver.models";

/**
 * Whether a route can skip re-rendering. Compared field by field rather than by reference because the live
 * map rebuilds its route objects on every tracking poll: a shallow `memo` would see a new object each time and
 * re-render every route on the map several times a minute, geometry unchanged.
 */
export const areMapLibreRoutePropsEqual = (
  prev: IMapLibreRouteResolverProps,
  next: IMapLibreRouteResolverProps,
): boolean =>
  prev.liveMapDisplayMode === next.liveMapDisplayMode &&
  prev.direction === next.direction &&
  prev.isCrowdedMap === next.isCrowdedMap &&
  prev.hasUnsavedStationsChange === next.hasUnsavedStationsChange &&
  prev.route.rideId === next.route.rideId &&
  prev.route.routePolyline === next.route.routePolyline &&
  prev.route.isManualPolylineEdit === next.route.isManualPolylineEdit &&
  prev.route.isTrackingRoute === next.route.isTrackingRoute &&
  prev.route.courseLineColor === next.route.courseLineColor &&
  prev.route.carTrackingInfo?.courseCode ===
    next.route.carTrackingInfo?.courseCode &&
  routeGeometryKey(prev.route) === routeGeometryKey(next.route);
